import { render, staticRenderFns } from "./IntegrationSoftwareServices.vue?vue&type=template&id=72d3a0e0&"
import script from "./IntegrationSoftwareServices.vue?vue&type=script&lang=js&"
export * from "./IntegrationSoftwareServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports